import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  ButtonGroup,
  Tooltip,
  IconButton,
} from "@mui/material";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import TuneIcon from "@mui/icons-material/Tune";
import MouseIcon from "@mui/icons-material/Mouse";
import { Check } from "lucide-react";
import ButtonIcon from "../ButtonIcon/ButtonIcon";

export default function ControlsGuide({ isNight = false }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* <Tooltip title="Keyboard Controls">
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            position: "absolute",
            top: "calc(9vh + 100px)",
            right: "3vh",
            zIndex: 1000,
            color: "rgba(0,0,0,0.5)",
            background: "#fff",
            "&:hover": { background: "rgba(255, 255, 255, 0.7)" },
            borderRadius: "2px",
            boxShadow: "#0000001a 0px 0px 50px 0px",
            padding: "3px",
          }}
        >
          <KeyboardIcon />
        </IconButton>
      </Tooltip> */}
      <ButtonIcon
        tooltipTitle={"Keyboard Controls"}
        onClick={() => setOpen(true)}
        icon={<KeyboardIcon />}
        top={"calc(9vh + 100px)"}
        right={"3vh"}
        isNight={isNight}
      ></ButtonIcon>

      {/* Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            backgroundColor: isNight ? "#3d4658" : "#fff",
            color: isNight ? "#eef2f7" : "inherit",
            transition: "color 0.35s ease, background-color 0.35s ease",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "0.91rem",
            fontWeight: "bold",
            padding: "3vh 3vh 2vh 3vh",
          }}
        >
          Keyboard & Controls Guide
        </DialogTitle>

        <DialogContent sx={{ padding: "3vh 3vh" }}>
          {/* Intro */}
          <Typography sx={{ fontSize: "calc(0.86rem + var(--large-screen-font-bump))" }}>
            Use the following controls to adjust quality and interact with the
            model.
          </Typography>

          <Box height={"2.5vh"} />

          {/* QUALITY SECTION */}
          <Box display="flex" alignItems="center" gap="1vh">
            <TuneIcon
              sx={{
                fontSize: "calc(1.06rem + var(--large-screen-font-bump))",
                opacity: 0.7,
                transition: "color 0.35s ease",
              }}
            />
            <Typography sx={{ fontSize: "calc(0.81rem + var(--large-screen-font-bump))", fontWeight: "bold" }}>
              Quality Presets
            </Typography>
          </Box>

          <Box height={"1vh"} />

          <Box pl={"2.5vh"}>
            <Typography sx={{ fontSize: "calc(0.76rem + var(--large-screen-font-bump))" }}>1 → Low</Typography>
            <Typography sx={{ fontSize: "calc(0.76rem + var(--large-screen-font-bump))" }}>2 → Medium</Typography>
            <Typography sx={{ fontSize: "calc(0.76rem + var(--large-screen-font-bump))" }}>3 → High</Typography>
            <Typography sx={{ fontSize: "calc(0.76rem + var(--large-screen-font-bump))" }}>4 → Ultra</Typography>
          </Box>

          <Box height={"2.5vh"} />

          {/* INTERACTION SECTION */}
          <Box display="flex" alignItems="center" gap="1vh">
            <MouseIcon
              sx={{
                fontSize: "calc(1.06rem + var(--large-screen-font-bump))",
                opacity: 0.7,
                transition: "color 0.35s ease",
              }}
            />
            <Typography sx={{ fontSize: "calc(0.81rem + var(--large-screen-font-bump))", fontWeight: "bold" }}>
              Interaction
            </Typography>
          </Box>

          <Box height={"1vh"} />

          <Box pl={"2.5vh"}>
            <Typography sx={{ fontSize: "calc(0.76rem + var(--large-screen-font-bump))" }}>
              Ctrl + Drag → Move model
            </Typography>
          </Box>

          <Box height={"3vh"} />

          {/* ACTION BUTTON (matches your modal style) */}
          <ButtonGroup sx={{ float: "right" }}>
            <Button
              variant="contained"
              onClick={() => setOpen(false)}
              sx={{
                fontSize: "calc(0.72rem + var(--large-screen-font-bump))",
                borderRadius: "0",
                backgroundColor: "#d32f2f",
                fontWeight: "bold",
                border: "none !important;",
              }}
            >
              Got it
              <Box width={"10px"} />
              <Check size={"15"} />
            </Button>
          </ButtonGroup>
        </DialogContent>
      </Dialog>
    </>
  );
}
